/**
 * Theme toggle controller
 * Handles light/dark theme switching
 * Loaded globally via layout.php
 */

const toggle = document.getElementById('theme-toggle') as HTMLButtonElement | null;

function getCurrentTheme(): string {
    return document.documentElement.dataset.theme || 'light';
}

function updateToggleText(): void {
    if (toggle) {
        toggle.textContent = getCurrentTheme() === 'dark' ? 'Dark' : 'Light';
    }
}

function setTheme(theme: string): void {
    document.documentElement.dataset.theme = theme;
    document.cookie = `theme=${theme};path=/;max-age=31536000;SameSite=Lax`;
    updateToggleText();
}

if (toggle) {
    updateToggleText();

    toggle.addEventListener('click', () => {
        const newTheme = getCurrentTheme() === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
    });
}
